import type { IntervalZone } from "~/entities/analysis-config/types";
import axiosInstance from "~/shared/api/axios-instance";

export type UpdateIntervalZoneDatum =
  | { actionType: "create"; data: Omit<IntervalZone, "id"> }
  | { actionType: "update" | "delete"; data: IntervalZone };

export async function updateIntervalZones(
  branchUid: string,
  versionId: number | undefined,
  dataToUpdate: UpdateIntervalZoneDatum[],
) {
  const converted = dataToUpdate.map(({ actionType, data }) => {
    const base: Record<string, unknown> = {
      key: data.key,
      pseudo_camera_orientation_id: data.cameraId,
      version: versionId,
      action_type: actionType,
    };

    if ("id" in data) {
      base.id = data.id;
    }

    if (data.analysisConfig) {
      base.analysis_setting_status = {
        name: data.analysisConfig.name,
        event_type: data.analysisConfig.eventType,
        coordinates: data.analysisConfig.coordinates,
      };
    } else {
      base.analysis_setting_status = null;
    }

    if (data.floorPlanConfig) {
      base.floor_plan_status = {
        coordinates: data.floorPlanConfig.coordinates,
      };
    } else {
      base.floor_plan_status = null;
    }

    return { version: versionId, action_type: actionType, data: base };
  });

  const { data } = await axiosInstance.patch(
    `branches/${branchUid}/interval-zones/`,
    converted,
  );
  return data;
}
